init_action_reveal = ->
  $('.reveal.ask-for-action').each((index,reveal) ->
    $(reveal).find('.deny-action').on('click', (button) ->
      $(reveal).foundation('close')
    )
    $(reveal).find('.call-hidden-link').on('click', (button) ->
      link_id = $(this).data('link-id')
      $("##{link_id}").find('a').click()
      $(reveal).foundation('close')
    )

    # don't submit form if field is empty
    $(reveal).find('input[type="submit"][data-close-if-empty]').on('click', (event) ->
      form_field_id = $(this).data('form-field')
      if !form_field_id
        return
      form = $(this).closest('form')
      form_field = $(form).find(form_field_id)
      if !$(form_field).val()
        event.preventDefault()
        $(reveal).foundation('close')
    )
  )

$ ->
  init_action_reveal()

$(document).on 'turbolinks:load', ->
  init_action_reveal()